export const FETCH_ITEMCATEGORY_INIT_ACTION = "FETCH_ITEMCATEGORY_INIT_ACTION";
export const FETCH_ITEMCATEGORY_SUCCESS_ACTION =
  FETCH_ITEMCATEGORY_INIT_ACTION + "_SUCCESS";
export const FETCH_ITEMCATEGORY_FAIL_ACTION =
  FETCH_ITEMCATEGORY_INIT_ACTION + "_ERROR";

export const ADD_ITEMCATEGORY_INIT_ACTION = "ADD_ITEMCATEGORY_INIT_ACTION";
export const ADD_ITEMCATEGORY_SUCCESS_ACTION =
  ADD_ITEMCATEGORY_INIT_ACTION + "_SUCCESS";
export const ADD_ITEMCATEGORY_FAIL_ACTION =
  ADD_ITEMCATEGORY_INIT_ACTION + "_ERROR";

export const EDIT_ITEMCATEGORY_INIT_ACTION = "EDIT_ITEMCATEGORY_INIT_ACTION";
export const EDIT_ITEMCATEGORY_SUCCESS_ACTION =
  EDIT_ITEMCATEGORY_INIT_ACTION + "_SUCCESS";
export const EDIT_ITEMCATEGORY_FAIL_ACTION =
  EDIT_ITEMCATEGORY_INIT_ACTION + "_ERROR";

export const DELETE_ITEMCATEGORY_INIT_ACTION = "DELETE_ITEMCATEGORY_INIT_ACTION";
export const DELETE_ITEMCATEGORY_SUCCESS_ACTION =
  DELETE_ITEMCATEGORY_INIT_ACTION + "_SUCCESS";
export const DELETE_ITEMCATEGORY_FAIL_ACTION =
  DELETE_ITEMCATEGORY_INIT_ACTION + "_ERROR";

export function itemCategorylist() {
  return {
    type: FETCH_ITEMCATEGORY_INIT_ACTION
  };
}
export function AddItemCategory(value) {
  return {
    type: ADD_ITEMCATEGORY_INIT_ACTION,
    value: value
  };
}
export function EditItemCategory(value) {
  return {
    type: EDIT_ITEMCATEGORY_INIT_ACTION,
    value: value
  };
}
export function DeleteItemCategory(value) {
  return {
    type: DELETE_ITEMCATEGORY_INIT_ACTION,
    value: value
  };
}
export function itemCategorySlectedPage(value) {
  return {
    type: FETCH_ITEMCATEGORY_INIT_ACTION,
    value: value
  };
}
